import { displayName } from '../../package.json'
export default {
  title: displayName,
  logo: 'icon',
  tenantId: '773738',
  unitName: '生态环境部',
  clientId: 'sword',
  clientSecret: 'sword_secret',
  //登录校验方式 password OR captcha
  grantType: 'captcha',
  /**显示租户 */
  showTenant: 'false',
  /**用户登录接口*/
  loginAction: 'api.admin.oauth.login',
  /**菜单接口*/
  menusAction: 'api.admin.menu.getRoutes',
  /**刷新验证码 */
  captchaAction: 'api.admin.oauth.captcha',
  /**用户信息接口*/
  userInfoAction: 'api.admin.user.getInfo',
  /**用户按钮权限接口 */
  userButtonsAction: 'api.admin.menu.getButtons',
  /**顶部菜单 */
  topMenuAction: 'api.admin.menu.getTopMenu',
  /**默认首页*/
  defaultPage: '/fill/in/punish',
  /**预览地址*/
  filePreviewUrl: '/api/onlinePreview/onlinePreview',
  /**
   * 预览地址模式
   * blank 加载到一个新的窗口
   * self 打开一个新窗口并且在框架内
   * dialog 弹框当时打开
   */
  filePreviewTarget: 'dialog',
  /**服务器地址*/
  baseURL: import.meta.env.VITE_APP_BASE_URL,
  /**超时时间 秒*/
  timeout: 180,
  /**默认皮肤组件 */
  skinCode: 'blue',
  /**默认登录组件 */
  loginCode: 'blue3',
  /**文件上传路径 */
  uploadFileUrl: import.meta.env.VITE_APP_UPLOAD_FILE_URL,
  /**流程设计器URl地址 */
  flowDesignUrl: import.meta.env.VITE_FLOW_DESIGN_URL,
  /**开启页面认证 */
  openPagePermission: false,
  /**开启按钮认证 */
  openButtonPermission: false,
  /**页面切换动画编码 */
  animateCode: 'fade',
  /**页面切换方向编码 */
  directCode: 'left',
  /**菜单分组模式 */
  menuGroup: false,
  /**显示顶部的首页 */
  showHeaderMainPage: false,
  /**显示头像 */
  showAvatar: false,
  /**显示设置字体 */
  showFontSize: false,
  /**显示锁屏 */
  showLockScreen: false,
  /**模式 */
  mode: 'production',
  password_encrypt_type: 'SHA-256'
}
